import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { AppState, Dispatch } from 'store/types'
import { Table } from 'components/UI/CompactTable'
import { Link } from 'components/UI/Link'
import { Search } from 'components/UI/Search'
import { routePath } from 'routes'
import {
  fetchEstimates,
  downloadPDF,
  goToPDF,
  getPDFOnEmail
} from 'ducks/estimates/operations'
import { getProfile } from 'ducks/profile/operations'
import { formatDateToString } from 'utils/dateFormats'
import { DotsButton, DropdownList } from 'components/common'
import DropMenu from 'components/UI/DropMenu'
import { MenuOption } from 'components/common/DropdownList'
import { ContentBlock } from 'components/common'
import Pagination from '../../components/UI/Pagination'

class EstimatesPage extends Component<Props, ReceivedProps> {
  constructor(props: Props) {
    super(props)

    this.state = {
      filtered: [],
      actualPage: 0,
      actualPages: [],
      pageNumbers: [],
      chunks: [],
      searchText: ''
    }
  }

  componentDidMount(): void {
    this.props.fetchEstimates(7, 0)
    this.props.getProfile()
    // this.getPaginationData(this.props.estimates)
    this.setState({ filtered: this.props.estimates })
  }
  componentDidUpdate(prevProps: any) {
    const { estimates = [], loadedPageNumber = 0 } = this.props
    // if (prevProps.estimates.length !== estimates.length) {
    //   this.getPaginationData(estimates)
    // }
    if (
      prevProps.loadedPageNumber !== loadedPageNumber ||
      prevProps.estimates.length !== estimates.length
    ) {
      this.setState({ filtered: estimates })
    }
  }

  onSearch = (text: string) => {
    this.setState({ searchText: text })
    if (!text) {
      this.props.fetchEstimates(7, 0)
      return
    }
    this.props.fetchEstimates(7, this.state.actualPage, text)
  }
  onHandleClear = () => {
    this.props.fetchEstimates(7, 0)
    this.setState({
      filtered: this.props.estimates,
      searchText: ''
    })
  }
  onPageChanged = (actualPage: number) => {
    const { searchText } = this.state
    if (searchText) {
      this.props.fetchEstimates(7, actualPage, searchText)
      return
    }
    this.setState({ actualPage })
    this.props.fetchEstimates(7, actualPage)
  }
  noItems = () => (
    <TextBlock>
      <p>You don’t have any estimates yet.</p>
      {/*<Link variant={'default'} to={routePath.ESTIMATES_START_PAGE}>*/}
      {/*  New Estimate*/}
      {/*</Link>*/}
    </TextBlock>
  )

  render() {
    const { estimates = [], estimatesTotalPages } = this.props
    const pages: Array<number | any[]> = []
    // @ts-ignore
    for (let a = estimatesTotalPages - 1; a > -1; a--) {
      pages.unshift(a)
    }
    const menuOptions: MenuOption[] = [
      {
        text: 'Download',
        onClick: (id: any) => {
          this.props.downloadPDF(id)
        }
      },
      {
        text: 'Print',
        onClick: (id: any) => {
          this.props.goToPDF(id)
        }
      },
      {
        text: 'Email',
        onClick: (id: any) => this.props.getPDFOnEmail(id)
      }
      // {
      //   text: 'Delete',
      //   variant: 'text-danger',
      //   onClick: () => console.log('Delete')
      // }
    ]

    const headers = {
      columns: [
        { name: 'Date Created' },
        { name: 'Estimation Id' },
        { name: 'Patient Name' },
        { name: 'Procedure Name' },
        { name: 'Patient Responsibility' }
      ]
    }

    const actionBlock = (id: any) => {
      return (
        <DropMenu target={<DotsButton />}>
          <DropdownList menuOptions={menuOptions} id={id} />
        </DropMenu>
      )
    }
    const getActionsBlock = (id: any) => {
      return actionBlock(id)
    }

    const getTableBody = (estimatesList: any[]) => {
      const { filtered = [] } = this.state
      const tableData = filtered.sort((a, b) => {
        return +new Date(b.createdAt) - +new Date(a.createdAt)
      })
      return tableData.map((row: any, i) => {
        const deductible = row.deductible ? row.deductible : '0'
        const copay = row.copay ? row.copay : '0'
        const patientResponsibility = row.patientResponsibility
          ? row.patientResponsibility
          : '0'
        const coInsurance = row.coInsurance ? row.coInsurance : '0'
        const procedureName = row.appointmentTypeEntityList.map((item: any) => {
          return item.appointmentCode + ' ' + item.description
        })
        const cpt4Name = row.cpt4EntitySet.map((item: any) => {
          return item.cpt4Code + ' ' + item.description
        })
        const viewProcedureName =
          procedureName.length === 1
            ? procedureName[0]
            :  procedureName.join(',')

        const viewCpt4Name =
        cpt4Name.length === 1
              ? cpt4Name[0]
              :  cpt4Name.join(',')

        return {
          id: row.id,
          columns: [
            formatDateToString(row.createdAt),
            row.id,
            row.dependentEntity === undefined || row.dependentEntity.firstName === undefined ? `${row.firstName} ${row.lastName}` : `${row.dependentEntity.firstName} ${row.dependentEntity.lastName}` ,
            !viewCpt4Name ? viewProcedureName : viewCpt4Name,
            `$${patientResponsibility}`
          ],
          hoverColumns: [
            `Estimated Deductible: $${deductible}`,
            `Estimated Co-Insurance: $${coInsurance}`,
            `Estimated Co-Pay: $${copay}`
          ]
        }
      })
    }

    return (
      <WrapBlock>
        <HeadTitle>
          <Title>My Estimates</Title>
          <RightHeadTitle>
            <Search
              onSearch={this.onSearch}
              onHandleClear={this.onHandleClear}
            />
            <Link variant={'default'} to={routePath.ESTIMATES_START_PAGE}>
              New estimate
            </Link>
          </RightHeadTitle>
        </HeadTitle>
        {estimates.length === 0 || this.state.filtered.length === 0 ? (
          <ContentBlock isCentered={true}>{this.noItems()}</ContentBlock>
        ) : (
          <>
            <Table
              header={headers}
              body={getTableBody(estimates)}
              actionBlock={getActionsBlock}
              goTo={(id, isNew) => `/estimate/${id}/${isNew}`}
            //   isNew={false}
            />
            <Pagination onPageChanged={this.onPageChanged} allPages={pages} />
          </>
        )}
      </WrapBlock>
    )
  }
}

// tslint:disable-next-line:no-empty-interface
interface ReceivedProps {
  filtered: any[]
  actualPage: number
  actualPages: number[]
  chunks: any
  pageNumbers: any
  searchText: string
}

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>
type Props = StateProps & DispatchProps & ReceivedProps

const mapStateToProps = (state: AppState) => ({
  isAccountCreated: state.auth.registrationData,
  estimates: state.estimates.data.content ? state.estimates.data.content : [],
  estimatesTotalPages: state.estimates.data.totalPages
    ? state.estimates.data.totalPages
    : 0,
  loadedPageNumber: state.estimates.data.number
    ? state.estimates.data.number
    : 0
})

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    { fetchEstimates, downloadPDF, goToPDF, getPDFOnEmail, getProfile },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EstimatesPage)

const WrapBlock = styled.div``

const Title = styled.h1`
  font-size: 30px;
  font-weight: 600;
  color: #152735;
  text-align: center;
  padding: 0;
`

const HeadTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2.5rem;
`

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;

  p {
    color: #152735;
    margin-bottom: 1.5rem;
  }
`
const RightHeadTitle = styled.div`
  display: flex;
  flex-direction: row;

  > a,
  > button {
    margin-left: 30px;
    min-width: auto;
  }
`

// chunk(array: any[], size: number) {
//   const chunkedArr = []
//   // tslint:disable-next-line:prefer-for-of
//   for (let i = 0; i < array.length; i++) {
//     const last = chunkedArr[chunkedArr.length - 1]
//     if (!last || last.length === size) {
//       chunkedArr.push([array[i]])
//     } else {
//       last.push(array[i])
//     }
//   }
//   return chunkedArr
// }
// getPaginationData = (data: any[] | undefined) => {
//   if (data) {
//     const chunks = this.chunk(data, 7)
//     const pageNumbers = Object.keys(chunks)
//     this.setState({ pageNumbers, chunks, filtered: data.slice(0, 7) })
//   }
// }
